module.exports = __webpack_public_path__ + "img/discuss-screen-dark-en.e720cdcb.png";